import styled, { useTheme } from 'styled-components';
import BoxContainer from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import LXIcon from '../../core/components/buttons/lxIcon';
import { LXbody, LXh1, LXh4, LXh5 } from '../../core/texts/lxText';
import { ReactComponent as ProgressIcon } from '../../../assets/icons/testingProgress.svg';
import { ReactComponent as Next } from '../../../assets/icons/next.svg';
import Row from '../../core/components/box/row';
import FlexBox from '../../core/components/box/flexBox';
import { TestStatusDto } from '../../../2_domain/test/test';
import LXSpinner from '../../core/spinner/lx_spinner';
import useProgressTestBoardController from '../../../1_application/dashboard/progressTestBoardController';

const ProgressListItem = styled.div`
  align-items: center;
  display: flex;
  font-family: 'Outfit';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  height: 18px;
  line-height: 18px;
  color: ${(props) => props.color ?? props.theme.colors.body};
  margin-bottom: 10px;
  &:marker {
    content: '•';
  }
`;

interface TestingProgressProps {
  width?: string;
  height?: string;
  fromDate?: Date;
  endDate?: Date;
  statusOthers: TestStatusDto[];
}

const TestingProgress = ({
  width,
  height,
  statusOthers,
  fromDate,
  endDate,
}: TestingProgressProps) => {
  const theme = useTheme();
  const t = useProgressTestBoardController(fromDate, endDate, statusOthers);

  const ProgressList = t.notCompletedTest.map((test, idx) => {
    const isCountZero = test.totalElements === 0;
    const progressItem = (
      <Row
        onClick={
          isCountZero ? undefined : t.navigateToStatus(test.testStatus.status)
        }
        width="243px"
        alignItems="center"
      >
        <LXbody>{`• ${test.testStatus.label}`}</LXbody>
        <FlexBox></FlexBox>
        <LXh5
          fontWeight={isCountZero ? 400 : 600}
          color={isCountZero ? theme.colors.disabled : theme.colors.title}
        >
          {isCountZero ? '0' : test.totalElements}
        </LXh5>
        <Next
          color={isCountZero ? theme.colors.disabled : theme.colors.title}
        ></Next>
      </Row>
    );
    return <ProgressListItem key={idx}>{progressItem}</ProgressListItem>;
  });

  if (t.loading)
    return (
      <BoxContainer width={width} height={height}>
        <LXSpinner></LXSpinner>
      </BoxContainer>
    );
  return (
    <BoxContainer width={width} height={height} padding="24px 30px 20px 30px">
      <Column>
        <LXh4>{theme.texts.testingInProgress}</LXh4>
        <SizedBox height={24}></SizedBox>
        <Row alignItems="center">
          <LXIcon
            icon={ProgressIcon}
            width={'48px'}
            backgroundColor={theme.colors.blueLight + '33'}
          ></LXIcon>
          <SizedBox width={16}></SizedBox>
          <LXh1 height="32px">{t.totalCount}</LXh1>
        </Row>
      </Column>
      <SizedBox height={43}></SizedBox>
      {ProgressList}
    </BoxContainer>
  );
};

export default TestingProgress;
